import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {AssetSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {AssetTypeEnum} from './assetItem'

export const MediaSchema = buildEntrySchemaFor('media', {
  fields: z.lazy(() =>
    z.object({
      title: z.string(),
      assetType: AssetTypeEnum,
      optionImage: safeOptional(AssetSchema),
      optionVideo: safeOptional(AssetSchema),
      optionPoster: safeOptional(AssetSchema),
      autoplay: safeOptional(z.boolean()),
      videoSource: safeOptional(z.string()),
    }),
  ),
})
export type Media = z.infer<typeof MediaSchema>
